import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbToastModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { AlertsContainerComponent } from './components/alerts-container.component';
import { ConfirmDeleteComponent } from './components/confirm-delete.component';
import { CurrencyInputComponent } from './components/currency-input.component';
import { EmptyComponent } from './components/empty.component';
import { FeedbackComponent } from './components/feedback-container.component';
import { HeaderComponent } from './components/header.component';
import { LogoutCountdownComponent } from './components/logout-countdown.component';
import { NumpadComponent } from './components/numpad.component';
import { PrinterStatusComponent } from './components/printer-status.component';
import { SidebarButtonComponent } from './components/sidebar-button.component';
import { VersionMismatchModalComponent } from './components/version-mismatch-modal.component';
import { SidebarComponent } from './components/sidebar.component';
import { SoundControlComponent } from './components/sound-control.component';
import { AutofocusDirective } from './directives/autofocus.directive';
import { LoadingComponent, LoadingDirective } from './directives/loading-overlay.directive';
import { ScrollbarResizeDirective } from './directives/scrollbar-resize.directive';
import { SelectTextOnFocusDirective } from './directives/select-on-focus.directive';
import { FeatureFlagDirective } from './features/feature-flag.directive';
import { DesktopLayoutComponent } from './layout/desktop-layout.component';
import { VersionComponent } from './components/version.component';
import { LayoutPage } from './layout/layout.page';
import { SCREEN_LAYOUT_PROVIDER } from './layout/layout.provider';
import { MobileLayoutComponent } from './layout/mobile-layout.component';
import { DateDiffFromNowPipe } from './pipes/date-diff-from-now.pipe';
import { DateCompletedAtPipe } from './pipes/date-completed-at.pipe';
import { DateFromNowPipe } from './pipes/date-from-now.pipe';
import { FormatTimePipe } from './pipes/format-time.pipe';
import { FormatDatePipe } from './pipes/format-date.pipe';
import { FormatterPipe } from './pipes/formatter.pipe';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgbToastModule,
    NgbPopoverModule,
  ],
  declarations: [
    SidebarComponent,
    SidebarButtonComponent,
    HeaderComponent,
    MobileLayoutComponent,
    DesktopLayoutComponent,
    LayoutPage,
    DateFromNowPipe,
    AutofocusDirective,
    NumpadComponent,
    CurrencyInputComponent,
    VersionComponent,
    LoadingComponent,
    LoadingDirective,
    SelectTextOnFocusDirective,
    AlertsContainerComponent,
    ConfirmDeleteComponent,
    EmptyComponent,
    DateDiffFromNowPipe,
    DateCompletedAtPipe,
    FeatureFlagDirective,
    PrinterStatusComponent,
    LogoutCountdownComponent,
    FeedbackComponent,
    ScrollbarResizeDirective,
    FormatterPipe,
    FormatTimePipe,
    FormatDatePipe,
    VersionMismatchModalComponent,
    SoundControlComponent,
  ],
  providers: [
    SCREEN_LAYOUT_PROVIDER,
  ],
  exports: [
    LayoutPage,
    DateFromNowPipe,
    AutofocusDirective,
    NumpadComponent,
    CurrencyInputComponent,
    LoadingDirective,
    SelectTextOnFocusDirective,
    EmptyComponent,
    DateDiffFromNowPipe,
    DateCompletedAtPipe,
    FeatureFlagDirective,
    FeedbackComponent,
    ScrollbarResizeDirective,
    FormatterPipe,
    FormatTimePipe,
    FormatDatePipe,
  ],
})
export class CoreModule { }
